// extracted by mini-css-extract-plugin
export default {"login-tab":"LoginTab_login-tab__2dbNj"};